module.exports = __webpack_public_path__ + "media/images/covid/spray_ico-2c7b7ade5b5e665634ad3b368a851403.png";